/* global DPI_STATS_TMOUT_MS, views, globalNavigate */
import React, { useContext, useEffect } from "react";
import Report from "views/Statistics/Report/TotalVolume/component";
import ExportButton from "./Export";
import ActionsContext from "common/ActionsContext";
import { expressTarget, getBqnIdCmdPart } from "common/api";
import { parseSubscriberBandwidthShare } from "../api";
import * as d3 from "d3";
import View from "common/View";
import Help from "./Help";
import {hoursScopeChoices} from "common/constants"

const wholeInterval = (hours, base = 60 /*minutes*/) => hours * base;

const doSpeedTotalsRetrieval = (
  target,
  hours = 72,
  categories = 20,
  directions = "all",
  output = "ip-addresses",
  mode,
  bqnId
) =>
  expressTarget(target).then((expressedTarget) =>
    ifCl.run(
      `show statistics subscribers top ${expressedTarget} ${output} direction ${directions} categories ${
        categories - 1
      } hours ${hours} interval ${wholeInterval(hours)}${getBqnIdCmdPart(mode, bqnId)}`,
      { timeout: DPI_STATS_TMOUT_MS }
    )
  );

const parseSubscriberBandwidthShareTotals = (input) =>
  parseSubscriberBandwidthShare(input, { omitTimeline: true });

const retrieval = ({ target, hours, categories, directions, output, mode, bqnId }) =>
  doSpeedTotalsRetrieval(target, hours, categories, directions, output, mode, bqnId)
    .then(parseSubscriberBandwidthShareTotals)
    .catch((error) => console.error(error) || error)

const formatThousandsAndDecimals = d3.format(",.2f");

const formatDecimals = (value) =>
  value === undefined ? "--" : formatThousandsAndDecimals(value);

const TotalVolumeVsDPI = ({ volume = 0 }) => (
  <h4 className="align-left">Total volume: {formatDecimals(volume)} GB</h4>
);
const thisViewUrl = "viewSubscribersTotalVolume";

const SubscriberDetailsView = () => {
  const actions = useContext(ActionsContext);
  useEffect(() => {
    return actions.recv("open-category", function ({ category, params }) {
      const { name } = category;
      const [addr, subsId] =
        params.output === "ip-addresses" ? [name, null] : [null, name];
      views.doKeep(thisViewUrl);
      globalNavigate("viewSubsDetail", {
        addr,
        subsId,
        returnView: thisViewUrl,
      });
    });
  }, []);
  return null;
};
const monthOrLess = ({ value }) => value <= 720;
const customSettings = {
  hours: { options: hoursScopeChoices.filter(monthOrLess) },
};
const SubscribersTotalVolume = () => {
  const actions = useContext(ActionsContext);

  return (
    <View id="viewSubscribersTotalVolume"
      title="Top subscribers"
      subtitle={
        <small id="inspectableCategories">
          Click on the area in the pie-chart to see subscriber details
        </small>
      }
      Help={Help}
    >
      <Report
        itemsFrom="subscribers"
        itemsTotalFrom="volume"
        itemsValueFrom="share"
        valueIsShare={true}
        settings={customSettings}
        provider={retrieval}
        actions={actions}
        enabled={{ output: true, filter: false, directions: true }}
        Totals={TotalVolumeVsDPI}
        targetTooltip="Click to see subscriber details"
        graphTitle={null}
        Export={ExportButton}
      />
      <SubscriberDetailsView />
    </View>
  );
};

export default SubscribersTotalVolume;
